// extracted by mini-css-extract-plugin
module.exports = {"container-posicao-icone":"IconeBlackList_container-posicao-icone__3v6zE","container-icone":"IconeBlackList_container-icone__yEqBI"};